import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import MUIDataTable from 'mui-datatables';
import React, {Component} from 'react';
import toastr from "toastr";
import _ from 'lodash';
import {getJwt} from '../../../services/authService';

import http from "../../../services/httpService";
import Theme from '../../common/MuiTheme';
import ChartLoader from '../../utils/chart-loader';

import {paginate} from '../../utils/paginate_posts'

import {Menu, MenuItem, Tag, Spinner, Popover, Position} from "@blueprintjs/core";
import {
    Cell,
    Column,
    CopyCellsMenuItem,
    SelectionModes,
    RenderMode,
    Table,
    Utils,
    TableLoadingOption,
} from "@blueprintjs/table";
import ItemsPerPage from '../../common/ItemsPerPage';
import Pagination from '../../common/Pagination';
import TableNoData from '../../common/TableNoData';
import ReactGA from "react-ga";
import CampaignDetailsModal from "../../modals/CampaignDetailsModal";
import sizeMe from 'react-sizeme';


const optionsPageSize = [
    {value: 10, text: 10},
    {value: 25, text: 25},
    {value: 50, text: 50},
];
/* Heights for every part of MultiPost post */
const multiPostGlobalPartHeight = 70;
const multiPostSinglePostHeight = 50;

/* Spinner Components for loader in blueprint tables */
let spinnerComponent = <div style={{marginBottom: 7}}><Spinner size={15}/></div>
let horizontalClickedSpinner = <div
    style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
    <i className="fas fa-envelope-open" style={{color: '#18A9E3'}}></i>
    <div style={{marginLeft: 5}}><Spinner size={15}/></div>
    <div style={{marginLeft: 5}}><Spinner size={15}/></div>
</div>;

const facebook_app_graph_url = process.env.REACT_APP_FB_URL;
const facebook_app_marketing_url = process.env.REACT_APP_FB_MARKETING_URL;

class FBMessengerCampaignPerformance extends Component {
    constructor(props) {
        super(props);
        this.state = {
            campaigns: [],
            posts: '',
            totalPosts: '',
            totalPages: '',
            totalCampaigns: 0,
            total_subscribers: 0,
            selectedSource: '',
            push_subscribers: [],
            pageSize: 10,
            currentPage: 1,
            lastPage: false,
            lastPageSize: '',
            paging: '',
            selectedAdAccount: '',
            sortColumn: {
                path: "updated_at",
                order: "asc"
            },
            loader: false,
            selectedCampaignPerformance: 'MESSAGES',
            preview: '',
            forceTableRerender: false,
            selectedSubType: this.props.selectedSubType.name || '',
            selectedSubTypeFinished: '',
            selectedType: this.props.selectedType.name || '',
            selectedTypeFinished: '',
            rowHeights: [],
            tableColumnsWidth: [],
            minTableWidth: 500,
            lastColumnWidth: '',

            //modal data
            campaignDetailsModal: false,
            campaignId: '',
            sentFrom: [],
            sendTime: {
                date: '',
                time: ''
            },
            message: '',
            segments: ['everything'],
            summary: {
                delivered: '',
                deliveredPercentage: '',
                notDelivered: '',
                notDeliveredPercentage: '',
                buffered: '',
                clicked: '',
                clickedPercent: ''
            },
            fb_page_connected: false
        }

        toastr.options = {
            closeButton: true,
            positionClass: "toast-bottom-full-width",
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "8000",
            extendedTimeOut: "1000",
        };
    }

    
    openModal = async (index) => {
        // console.log('kliknuo sam: ', index, this.state.posts[index])
        let item = this.state.posts[index]
        //console.log('post: ', this.state.posts[index]);

        let dateConverted = item.sent_at ? this.props.isodateToDate(item.sent_at) : ''
        let date = dateConverted ? dateConverted.substr(0, dateConverted.indexOf(' ')) : 'No date';
        let time = dateConverted ? dateConverted.substr(dateConverted.indexOf(' ') + 1) : 'No time';
        // let date = item ? item.sent_at_timezone ? item.sent_at_timezone.substr(0, item.sent_at_timezone.indexOf(' ')) : 'No date' : 'No date';
        // let time = item ? item.sent_at_timezone ? item.sent_at_timezone.substr(item.sent_at_timezone.indexOf(' ') + 1) : 'No time' : 'No time';

        let sent = this.state.selectedTypeFinished === 'Single Message' ? this.state.posts[index].data.sent_post_total : this.state.posts[index].sent_multi_total_count;
        let delivered = sent;

        let notDelivered = sent - delivered
        let notDeliveredPercentage = (notDelivered / sent) * 100 + '%'
        let sentFrom = []
        if (this.state.posts.length > 0) {

            //console.log('post: ', this.state.posts[index])
            let i;
            let k;
            if (this.state.selectedType.name === 'Single Message') {
                //console.log('single message')
                for (i = 0; i < this.state.posts[index].data.facebook_pages.length; i++) {
                    if (this.state.posts[index].data.facebook_pages[i].sent_post !== 0) {
                        sentFrom = [...sentFrom, String(this.state.posts[index].data.facebook_pages[i].page)]
                    }
                }
            } else if (this.state.posts[index].posts && this.state.posts[index].posts.length) {

                //console.log('multiple messages')
                for (i = 0; i < this.state.posts[index].posts.length; i++) {

                    // console.log('i: ', i)
                    // console.log('facebook pages length: ', this.state.posts[index].posts[i].data.facebook_pages.length)
                    for (k = 0; k < this.state.posts[index].posts[i].data.facebook_pages.length; k++) {
                        // console.log('i: ', i)
                        // console.log('k: ', k)
                        // console.log('pages in carousel: ', this.state.posts[index].posts[i].data.facebook_pages[k])
                        if (this.state.posts[index].posts[i].data.facebook_pages[k].sent_post !== 0) {
                            if (!sentFrom.includes(String(this.state.posts[index].posts[i].data.facebook_pages[k].page))) {
                                sentFrom = [...sentFrom, String(this.state.posts[index].posts[i].data.facebook_pages[k].page)]
                            }
                        }
                    }
                }
            }
        }

        let clicked = this.state.selectedTypeFinished === 'Single Message' ? this.state.posts[index].data.opened_post_total : this.state.posts[index].opened_multi_total_count
        let newSendTime = {
            date: date,
            time: time
        }

        let newSummary = {}
        if (this.state.selectedTypeFinished === 'Single Message') {

            newSummary = {
                delivered: delivered,
                deliveredPercentage: item.data.sent_fb_post_total === 0 ? '0%' : item.data.sent_fb_post_total / item.data.send_attempt_count * 100 + '%',

                notDelivered: sent === 0 ? 0 : notDelivered,
                notDeliveredPercentage: sent === 0 ? '0%' : notDeliveredPercentage,
                buffered: '',
                clicked: clicked,
                clickedPercent: clicked === 0 ? '0%' : (clicked / delivered) * 100 + '%'
            }
        } else if (this.state.selectedTypeFinished === 'Carousel Message') {
            newSummary = {
                delivered: delivered,
                deliveredPercentage: item.sent_multi_total_count === 0 ? '0%' : item.sent_multi_total_count / item.send_attempt_count_multi * 100 + '%',
                notDelivered: sent === 0 ? 0 : notDelivered,
                notDeliveredPercentage: sent === 0 ? '0%' : notDeliveredPercentage,
                buffered: '',
                clicked: clicked,
                clickedPercent: clicked === 0 ? '0%' : (clicked / delivered) * 100 + '%'
            }
        }

        this.setState({
            campaignDetailsModal: true,
            campaignId: this.state.posts[index].id,
            message: this.state.posts[index].content,
            segments: this.state.selectedTypeFinished === 'Single Message' ? this.state.posts[index].data.tags : this.state.posts[index].posts[0].data.tags,
            sendTime: newSendTime,
            summary: newSummary,
            sentFrom
        })
    }

    getPostsData = async () => {
        //console.log('getPostData started')
        try {
            // this.setState({loader: false})
            await this.setState({loader: true})
            const pageSize = await this.state.pageSize;
            let selectedSubType = await this.props.selectedSubType;
            let selectedType = await this.props.selectedType;
            let selectedSource = await this.props.selectedSource || '';
            // let selectedSource = '1160';

            // This is used for case where Show All - Autopush selector is used

            // let apiCallType = await selectedSubType.name === 'Single Message' ? selectedType.name === 'Show All' ? 'facebook_all_single_posts' :
            //     selectedType.name === 'Autopush' ? 'facebook_single_posts' : 'facebook_custom_posts' : selectedSubType.name === 'Carousel Message' ?
            //     selectedType.name === 'Show All' ? 'facebook_all_multiple_posts' : selectedType.name === 'Autopush' ?
            //         'facebook_auto_multiple_posts' : 'facebook_custom_multiple_posts' : 'facebook_plain_text_posts';

            let apiCallType = await selectedType.name === 'Single Message' ? 'facebook_all_single_posts' : 'facebook_custom_multiple_posts';


            //console.log('api/' + apiCallType + '/page_size/' + pageSize + '/feed/' + selectedSource + '?page=' + this.state.currentPage);

            const result = await http.get('api/' + apiCallType + '/page_size/' + pageSize + '/feed/' + selectedSource + '?page=' + this.state.currentPage, {headers: {authorization: getJwt()}});

            //console.log('posts result: ', result);

            const data = await result.data;


            // console.log('subType, type and source: ', selectedSubType.name, selectedType, selectedSource, data)
            //this.props.selectedSubType.name === 'Carousel Message' ? [200,200,200,200,300,300,300,200,200,200] : [100,100,100,100,100,100,100,100,100,100],
            // console.log('data.posts: ', data.posts)
            let rowHeights = await this.state.selectedType.name ===
            'Carousel Message' ?
                await data.posts.data.map(post => post.posts.length > 0 ?
                    (post.posts.length * multiPostSinglePostHeight) + multiPostGlobalPartHeight :
                    multiPostGlobalPartHeight) :
                await this.props.selectedType.name === 'Single Message' ?

                    data.posts.map(() => 100) :
                    data.posts.data.map(post => 80 + 50 * post.posts.length);
            //console.log('get posts data - row heights: ', rowHeights)
            await this.setState({
                selectedSource,
                rowHeights,
                posts: selectedType.name === 'Single Message' ? data.posts ? data.posts.length > 0 ? data.posts : '' : '' :
                    data.posts.data ? data.posts.data.length > 0 ? data.posts.data : '' : '',
                selectedSubType: selectedSubType.name,
                selectedType: selectedType.name,
                totalPosts: data.total_posts,
                totalPages: data.total_pages,
                lastPage: (data.total_pages < 1) || (this.state.currentPage === data.total_pages) ? true : false,
                lastPageSize: ((data.total_posts % this.state.pageSize) === 0) ? data.total_posts === 0 ? 0 : this.state.pageSize :
                    ((data.total_posts % this.state.pageSize) < 0) ? data.total_posts : data.total_posts % this.state.pageSize,
                selectedSubTypeFinished: this.props.selectedSubType.name,
                selectedTypeFinished: this.props.selectedType.name,
                loader: false
            })
            // console.log('Hajhoooooo: ', data, rowHeights, this.state.posts.length, this.state.lastPage ? this.state.lastPageSize === this.state.posts.length ?
            //     this.state.lastPageSize : this.state.posts.length :
            //     this.state.pageSize === this.state.posts.length ? this.state.pageSize : this.state.posts.length)
            if (!this.state.posts) {
                this.setState({loader: false})
            }
            await this.setState({forceTableRerender: true})
            await this.setState({forceTableRerender: false})
        } catch (ex) {
            await this.setState({loader: false})
            if (ex.response && ex.response.status === 404)
                // toastr.error("Something went wrong... Please refresh and try again.");
                this.setState({posts: '', rowHeights: []})
            if (ex.response && ex.response.status === 401) {
                toastr.error('Error Code #16040: '+ ex.response.data.message);
                this.props.history.push('/logout');
            }
        }
    }

    async componentDidMount() {
      //  ReactGA.pageview(window.location.pathname + window.location.search);

        
        try {
            await this.getPostsData()
        } catch (ex) {
            if (ex.response && ex.response.status === 404)
                toastr.error("Error Code #16041: Something went wrong... Please refresh and try again.");
            if (ex.response && ex.response.status === 401) {
                toastr.error('Error Code #16042: '+ex.response.data.message);
                this.props.history.push('/logout');
            }
        }

        this.checkFbConnected()

        // this.getPreview();
    }



    componentDidUpdate = async () => {
        // if (this.state.selectedSubType !== this.props.selectedSubType) {
        //     await this.setState({
        //         selectedSubType: this.props.selectedSubType
        //     })
        // }
        /* Current Page should be always set back to 1 for new api call because it may not have page greater than 1 to return */
        if (this.state.selectedAdAccount !== this.props.user.add_account_id) {
            this.setState({
                currentPage: 1,
                selectedAdAccount: this.props.user.add_account_id
            })
        }
        if ((this.state.selectedType !== this.props.selectedType.name) && this.props.selectedType) {
            // console.log('selectedTypeChanged')

            await this.setState({
                loader: false,
                currentPage: 1,
                selectedType: this.props.selectedType.name
            })
            this.getPostsData();
        }

        if ((this.state.selectedSubType !== this.props.selectedSubType.name) && this.state.selectedSubType && this.props.selectedSubType) {
            // console.log('selectedSubTypeChanged')
            await this.setState({
                loader: false,
                currentPage: 1,
                selectedSubType: this.props.selectedSubType.name,
            })
            this.getPostsData();
        }


        if (this.state.selectedSource !== this.props.selectedSource) {
            this.setState({
                loader: true,
                selectedSource: this.props.selectedSource
            })
            this.getPostsData();
            this.checkFbConnected()
        }

        // this.getPreview();
    }

    checkFbConnected = () => {
        let {user_facebook_pages, facebook_pages_shared, selectedSource} = this.props;

        let count_pages = user_facebook_pages ? user_facebook_pages.length : "";
        let page_source_connected = (count_pages && selectedSource) ? user_facebook_pages.filter(el => {
            return (el.feed_id && el.feed_id.toString() === selectedSource.toString())
        }) : "";
        let count_shared_pages = facebook_pages_shared ? facebook_pages_shared.length : '';
        let shared_page_source_connected = (count_shared_pages && selectedSource) ? facebook_pages_shared.filter(el => {
            return (el.project_id && el.project_id.toString() === selectedSource.toString())
        }) : "";
        if ((page_source_connected && page_source_connected.length) || (shared_page_source_connected && shared_page_source_connected.length)) {
            this.setState({fb_page_connected: true})
        } else {
            this.setState({fb_page_connected: false})
        }
    }

    handlePageChange = async (number) => {
        let page = parseInt(number)
        if ((page !== 0) && (page !== this.state.lastPage)) {
            await this.setState({currentPage: page, loader: true});
            this.getPostsData()
        }
    };

    handleChangeCampaignsNumberPerPage = async (value) => {
        await this.setState({
            currentPage: 1,
            pageSize: value,
            lastPage: value > this.state.totalPosts ? true : this.state.lastPage,
            lastPageSize: value > this.state.totalPosts ? this.state.totalPosts : this.state.lastPageSize,
            loader: true
        })
        //console.log('Cao bella: ', this.state.pageSize)
        await this.getPostsData()
    }

    getPreview = async () => {
        if (!this.state.preview) {
            try {
                const add_account_token = 'EAAZAfK9tK44IBADVZBY4gjXJZBqKdAdCqQokgs5uVNiWm9PtZA7L1qvMF6w2qmNcZCPZAfTfZCCtoxhfW0N3KJZBeRkXLMCfpKuq3SNu3Ybvl9R7JSJU337WcOZB4ZCeO2RyZCLBsBN7j5iDk8GyF2FhUAlbI6C6obOPLB2rCekBNYeGQZDZD';
                const add_account_id = 'act_269773933645768';
                const campaign = await this.state.campaigns[0] || {};
                const link = 'https://nba.com';
                let object_story_spec = {
                    "page_id": 106911734110630,
                    "link_data": {
                        "call_to_action": {
                            "type": "USE_APP",
                            "value": {
                                "link": link
                            }
                        },
                        "description": "Ovde ide opis",
                        "link": link,
                        "message": "Probna Poruka",
                        "name": "Ovde ide ime",
                        "picture": link
                    }
                }
                // const adsetId = await campaign.adsets.data[0].id || '';
                // const result = await http.get('https://graph.facebook.com/v4.0/' + add_account_id + '/generatepreviews?access_token=' + add_account_token +
                //     '&ad_format=MOBILE_FEED_STANDARD&creative={"type":27, "object_id": 112886416838535}&post={"link":"https://nba.com", "message":"Lorem ipsum dolor sit amet","picture":"http://url.to/your/custom/image.jpg","name":"Facebook","caption":"www.facebook.com","description":"Lorem ipsum dolor sit amet"}')
                const result = await http.get(facebook_app_marketing_url + add_account_id + '/generatepreviews?access_token=' + add_account_token +
                    '&ad_format=MOBILE_FEED_STANDARD&creative={"object_story_spec": {"page_id": "106911734110630", "link_data": { "call_to_action": {"type": "LEARN_MORE", "value": { "link": "https://nba.com" } },"description": "Ovde ide opis", "link": "https://nba.com", "message": "Probna Poruka","name": "Ovde ide ime", "picture": "https://cdn.pixabay.com/photo/2015/12/01/20/28/road-1072823__340.jpg" }}}', {headers: {authorization: getJwt()}})

                // Ad formats: DESKTOP_FEED_STANDARD, FACEBOOK_STORY_MOBILE, INSTAGRAM_EXPLORE_CONTEXTUAL, INSTAGRAM_EXPLORE_IMMERSIVE, INSTAGRAM_STANDARD, INSTAGRAM_STORY, INSTANT_ARTICLE_RECIRCULATION_AD, INSTANT_ARTICLE_STANDARD, INSTREAM_VIDEO_DESKTOP, INSTREAM_VIDEO_MOBILE, MESSENGER_MOBILE_INBOX_MEDIA, MESSENGER_MOBILE_STORY_MEDIA, MOBILE_BANNER, MOBILE_FEED_BASIC, MOBILE_FEED_STANDARD, MOBILE_FULLWIDTH, MOBILE_INTERSTITIAL, MOBILE_MEDIUM_RECTANGLE, MOBILE_NATIVE, RIGHT_COLUMN_STANDARD, SUGGESTED_VIDEO_DESKTOP, SUGGESTED_VIDEO_MOBILE, WATCH_FEED_MOBILE"
                // const result = await http.get('https://graph.facebook.com/v5.0/' + add_account_id + '/generatepreviews?access_token=' + add_account_token +
                //     '&ad_format=MOBILE_FEED_STANDARD&creative=[{"object_story_spec": "' + object_story_spec + '"}]')


                const iframe = await result.data.data[0].body;
                await this.setState({preview: iframe})
            } catch (e) {
                //console.log('error: ', e)
            }
        }

    }

    /* Components for every Cell in Blueprint table, and for custom Loading tables */

    renderBodyContextMenu = (context) => {
        // console.log('Ovo je context: ', context)
        return (
            <Menu>
                <CopyCellsMenuItem context={context} getCellData={this.getCellData} text="Copy"/>
            </Menu>
        );
    };

    noMessengerRenderer = () => {
        return <div className='no-contacts-container panel-container margin-top-20'>
            <img src="/img/emptyStates/url_shortener_my_campaigns.gif"/>
            {
                !this.state.fb_page_connected ?
                    <h3>There is no Facebook Page connected to {this.props.selectedSourceName}</h3>
                    :
                    <h3>There is no data for this type of Facebook Messages.</h3>
            }
            {/*<p>There are no contacts imported, you can add a single contact or import multiple contacts.</p>*/}
            <div className='flex-direction-row justify-content-center'>
                {
                    !this.state.fb_page_connected ?
                        <button
                            onClick={() => this.props.history.push('/channels/messenger')}
                            className=' btn-action margin-bottom-10'>
                            Connect a Facebook Page
                        </button>
                        :
                        <button
                            onClick={() => this.props.history.push('/new/messenger')}
                            className=' btn-action margin-bottom-10'>
                            Start a Messenger Campaign
                        </button>
                }
            </div>
        </div>
    };

    tableLoaderRenderer = () => {
        return <div className='table-loader-container'>
            <ChartLoader/>
        </div>
    }

    getMuiTheme = () => createTheme(Theme)

    render() {
        const {
            pageSize,
            currentPage,
            sortColumn,
            searchQuery,
            sub_type,
            type_of_subscription,
            total_subscribers
        } = this.state;
        let {
            subscribers: subscribersAll,
            //push_subscribers: subscribersPush
        } = this.state;


        let filtered = subscribersAll;
        if (searchQuery) {
            if (sub_type) {
                filtered = subscribersAll.filter(m => m.subscriber_name.toLowerCase().includes(searchQuery.toLowerCase()));
            }
        }
        const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);
        const campaigns = paginate(sorted, currentPage, pageSize);

        const columns = [
            {
                name: "type",
                label: " ",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.posts[tableMeta.rowIndex];
                        return <i onClick={() => this.openModal(tableMeta.rowIndex)}
                                  className={item.type === 'custom_single' ? 'fas fa-eye type-icon' : 'fas fa-eye type-icon'}></i>
                    }
                }
            },
            {
                name: "sent",
                label: " Sent ",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.posts[tableMeta.rowIndex];
                        if (item && (this.state.selectedTypeFinished === 'Single Message')){
                            return <div className='min-width-70'>
                                <i className="fas fa-paper-plane type-icon"></i>
                                { item.data && item.data.send_attempt_count ? item.data.send_attempt_count : '' }
                            </div>
                        }else{
                            return <div className='min-width-70'>
                                <i className="fas fa-paper-plane type-icon"></i>
                                { item.send_attempt_count_multi === 0 ? '0' : item.send_attempt_count_multi }
                            </div>
                        }
                    }
                }
            },
            {
                name: "delivered",
                label: "Delivered",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.posts[tableMeta.rowIndex];
                        if (item && (this.state.selectedTypeFinished === 'Single Message')){
                            return <div>
                                <img className='margin-right-10' src='/img/double-tick-indicator.png'/>
                                {item.data.sent_fb_post_total}
                            </div>
                        }else{
                            return <div>
                                <img className='margin-right-10' src='/img/double-tick-indicator.png'/>
                                {item.sent_multi_total_count}
                            </div>
                        }
                    }
                }
            },
            {
                name: "delivered_percentage",
                label: "%",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.posts[tableMeta.rowIndex];
                        return  <div className='text-light-grey'>
                            {
                                this.state.selectedTypeFinished === 'Single Message' ?
                                    item && item.data ?
                                        item.data.sent_fb_post_total === 0 ? '0%' :
                                            item.data.sent_fb_post_total / item.data.send_attempt_count * 100 + '%'
                                        :
                                        ''
                                    :
                                    item.sent_multi_total_count === 0 ?
                                        '0%'
                                        :
                                        item.sent_multi_total_count / item.send_attempt_count_multi * 100 + '%'
                            }
                                </div>
                    }
                }
            },
            {
                name: "clicked",
                label: "Clicked",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.posts[tableMeta.rowIndex];
                        if (item && (this.state.selectedTypeFinished === 'Single Message')){
                            return <div className="">
                                <i className="fas fa-envelope-open" style={ { color: '#18A9E3' } }></i> { item.data.opened_fb_post_total }
                            </div>
                        }else if(item && (this.state.selectedTypeFinished === 'Carousel Message')){
                            return <div>
                                <div style={{
                                    height: multiPostGlobalPartHeight,
                                    display: 'flex',
                                    paddingTop: 20,
                                    marginTop: 15
                                }}>
                                    <i className="fas fa-envelope-open" style={{color: '#18A9E3', marginRight: 10}}></i>
                                    <p style={{ fontSize: '1.1666666666666667rem'}}>{item.opened_multi_total_count}</p>
                                </div>
                                {item.posts.map((post, index) =>
                                    <div key={index} style={{
                                        height: multiPostSinglePostHeight,
                                        alignItems: 'center'
                                    }}>
                                        <p style={{ fontSize: '1.1666666666666667rem', color: '$grey-border'}}><i className="fas fa-envelope-open" style={{
                                            color: '#18A9E3', marginRight: 10
                                        }}></i>
                                        {post.data.opened_fb_post_total}
                                        </p>
                                    </div>)}
                            </div>
                        }
                    }
                }
            },
            {
                name: "clicked_percentage",
                label: "%",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.posts[tableMeta.rowIndex];

                        return <div className='text-light-grey'>
                            {this.props.selectedType.name === 'Single Message' ?
                                item && item.data ?
                                    item.data.percent_fb_post_total === 0 ? item.data.percent_fb_post_total + '%' :
                                        item.data.percent_fb_post_total : ''
                                :
                                <div style={{marginTop: 38}}>
                                    <p className='text-center'
                                       style={{color: '$grey-border', fontSize: '1.1666666666666667rem'}}><span
                                        className='total-percentage'
                                    >{
                                        item ?
                                            item.percent_multi_total_count
                                            :
                                            ''
                                    }</span></p>
                                    {
                                        item && item.posts ? item.posts.map((post, index) =>
                                                <div key={index} style={{
                                                    height: multiPostSinglePostHeight,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}>
                                                    {this.state.loader ? horizontalClickedSpinner :
                                                        <p className='text-center full-width' style={{color: '#18A9E3',fontSize: '1.1666666666666667rem'}}>
                                                            {post.data.percent_fb_post_total}{post.data.percent_fb_post_total === 0 ? '%' : ''}
                                                        </p>}
                                                </div>)
                                            :
                                            ''
                                    }
                                </div>
                            }
                        </div>
                    }
                }
            },
            {
                name: "image",
                label: "Image",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.posts[tableMeta.rowIndex];

                        if (item && (this.state.selectedTypeFinished === 'Single Message')){
                            return <div className='image-cell'>
                                <img className='viber-image' src={ item.image }/>
                            </div>
                        } else if (item && (this.state.selectedTypeFinished === 'Carousel Message')) {
                            return <div className='image-cell-big' style={{height: 'auto'}}>
                                <div style={{height: 59}}></div>
                                {item.posts.map((post, index) => this.state.loader ?
                                    <div key={index} className='image-skeleton bp3-skeleton'/> : post.image ?
                                        <img
                                            key={index}
                                            src={post.image} style={{
                                            height: multiPostSinglePostHeight - 10,
                                            width: multiPostSinglePostHeight - 10,
                                            marginTop: 5,
                                            marginBottom: 5,
                                            marginWidth: 0
                                        }}/> : <div key={index} style={{
                                            height: multiPostSinglePostHeight - 10,
                                            width: multiPostSinglePostHeight - 10
                                        }}/>
                                )}
                            </div>
                        }

                    }
                }
            },
            {
                name: "title",
                label: "Title",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.posts[tableMeta.rowIndex];
                        if (item && (this.state.selectedTypeFinished === 'Single Message')){
                            return <div>
                                { item.title }
                            </div>
                        }else if(item && (this.state.selectedTypeFinished === 'Carousel Message')){
                            return <div>
                                <div style={{height: multiPostGlobalPartHeight, display: 'flex', alignItems: 'center'}}>
                                    <p style={{marginBottom: 0, fontWeight: 600, color: '$grey-border'}}>GROUPED POSTS</p>
                                </div>

                                {item.posts.map((post, index) => <div key={index} className={"multi-line-text-big-container"}
                                                                      style={{height: multiPostSinglePostHeight}}>
                                    {
                                        this.state.loader ?
                                            <div>
                                                <div className='bp3-skeleton text-skeleton'/>
                                                <div className='bp3-skeleton text-skeleton'/>
                                            </div>
                                            :
                                            <p className='multi-line-text-cell-big'>{post.title}</p>
                                    }
                                </div>)
                                }

                            </div>
                        }
                    }
                }
            },
            {
                name: "message",
                label: "Message",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.posts[tableMeta.rowIndex];
                        if (item && (this.state.selectedTypeFinished === 'Single Message')){
                            return <div className='mui-column-wrapper'>{ item.content }</div>
                        }else if(item && (this.state.selectedTypeFinished === 'Carousel Message')){
                            return <div>
                                <div style={{height: multiPostGlobalPartHeight}}/>
                                <div className={"multi-line-text-big-container"}>
                                    {item.posts.map((post, index) => <div key={index} className={"multi-line-text-big-container"}
                                                                          style={{height: multiPostSinglePostHeight}}>
                                        <p className="multi-line-text-cell-big"
                                           style={{
                                               height: multiPostSinglePostHeight - 10,
                                               marginBottom: 10
                                           }}>{post.content}</p>
                                    </div>)}
                                </div>
                            </div>
                        }
                    }
                }
            },
            {
                name: "link",
                label: "Link",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.posts[tableMeta.rowIndex];

                        if (item && (this.state.selectedTypeFinished === 'Single Message')){
                            return <div className='mui-column-wrapper'>
                                <div>
                                    <a href={item.short_url} target="_blank"><i className="fas fa-link type-icon"></i></a>
                                </div>
                            </div>
                        }else if(item && (this.state.selectedTypeFinished === 'Carousel Message')){
                            return <div style={{flexDirection: 'column', marginTop: 50}}>
                                    {item.posts.map((post, index) => <div key={index} className="cell-link-holder">
                                        <a href={post.short_url} target="_blank"><i className="fas fa-link type-icon-small"></i></a>
                                    </div>)}
                                </div>
                        }
                    }
                }
            },
            {
                name: "segments",
                label: "Segments",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.posts[tableMeta.rowIndex];
                        return <div>
                            {
                                item.tags && item.tags.length ?

                                    item.tags.map(tag =>
                                        <Tag
                                            className={['custom-tag', tag.toLowerCase() === 'immediate' ? 'bp3-intent-primary' : tag.toLowerCase() === 'daily' ?
                                                'bp3-intent-success' : tag.toLowerCase() === 'weekly' ? 'bp3-intent-warning' :
                                                    tag.toLowerCase() === 'weekly' ? 'custom-tag' : '']}
                                            key={tag}
                                        >
                                            {tag.toLowerCase()}
                                        </Tag>
                                    )
                                    : <Tag className='custom-tag'>everyone</Tag>
                            }
                            {
                                item.tags && item.tags.length > 3 ?
                                    <Popover
                                        content={
                                            <div className='popover-tags padding-10'>
                                                {item.tags.map(tag =>
                                                    <Tag
                                                        className={['custom-tag', tag.toLowerCase() === 'immediate' ? 'bp3-intent-primary' : tag.toLowerCase() === 'daily' ?
                                                            'bp3-intent-success' : tag.toLowerCase() === 'weekly' ? 'bp3-intent-warning' :
                                                                tag.toLowerCase() === 'weekly' ? 'custom-tag' : '']}
                                                        key={tag}
                                                    >
                                                        {tag.toLowerCase()}
                                                    </Tag>
                                                )}
                                                {/*<Tag className='custom-tag bp3-intent-primary'>Cao</Tag>*/}
                                                {/*<Tag className='custom-tag bp3-intent-primary'>Zdravo jos ne</Tag>*/}
                                                {/*<Tag className='custom-tag bp3-intent-primary'>Cao</Tag>*/}
                                                {/*<Tag className='custom-tag bp3-intent-primary'>Zdravo</Tag>*/}
                                                {/*<Tag className='custom-tag bp3-intent-primary'>Cao cao</Tag>*/}
                                                {/*<Tag className='custom-tag bp3-intent-primary'>Cao cao</Tag>*/}
                                            </div>
                                        }
                                        className={'bp3-popover-segments'}
                                        position={Position.LEFT}
                                    >
                                        <img src='/img/campaignPerformance/segments_spread.png'/>
                                    </Popover>
                                    :
                                    ''
                            }
                        </div>
                    }
                }
            },
            {
                name: "sent_at",
                label: "Sent at",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.posts[tableMeta.rowIndex];
                        let dateConverted = item.sent_at ? this.props.isodateToDate(item.sent_at) : ''
                        let date = dateConverted ? dateConverted.substr(0, dateConverted.indexOf(' ')) : 'No date';
                        let time = dateConverted ? dateConverted.substr(dateConverted.indexOf(' ') + 1) : 'No time';
                        // let date = item ? item.sent_at_timezone ? item.sent_at_timezone.substr(0, item.sent_at_timezone.indexOf(' ')) : 'No date' : 'No date';
                        // let time = item ? item.sent_at_timezone ? item.sent_at_timezone.substr(item.sent_at_timezone.indexOf(' ') + 1) : 'No time' : 'No time';
                        return <div className='mui-column-wrapper min-width-80'>
                            <p style={{marginBottom: 5}}>{date}</p>
                            <p style={{color: 'rgb(164, 175, 183)'}}>{time}</p>
                        </div>
                    }
                }
            }
        ];

        const options = {
            serverSide: true,
            count: this.state.totalPosts,
            filterType: 'none',
            selectableRows: 'none',
            rowsPerPage: this.state.pageSize,
            viewColumns: false,
            download: false,
            print: false,
            search: false,
            filter: false,
            sort: false,
            onChangeRowsPerPage: (number) => this.handleChangeCampaignsNumberPerPage(number),
            page: this.state.currentPage - 1,
            rowsPerPageOptions: [10, 25, 50, 100],
            rowsSelected: this.state.rowsSelected,
            textLabels: {
                body: {
                    noMatch: this.state.loader ?
                        this.tableLoaderRenderer()
                        :
                        'Sorry, there is no matching data to display',
                },
            },
            onTableChange: (action, tableState) => {
                // console.log(action, tableState);

                // a developer could react to change on an action basis or
                // examine the state as a whole and do whatever they want

                switch (action) {
                    case 'changePage':
                        this.handlePageChange(tableState.page + 1);
                        break;
                    case 'sort':
                        this.handleSortContacts(tableState.sortOrder)
                        break;
                    // default:
                    //     console.log('action not handled.');
                }
            },
            onRowSelectionChange: (currentRowsSelected, allRowsSelected, rowsSelected) => {
                this.setState({rowsSelected});
                this.handleCheck(rowsSelected)
                //console.log('currentRowsSelected: ', currentRowsSelected, ' allRowsSelected:', allRowsSelected, ' rowsSelected:', rowsSelected)
            }

        };

        return (
            <React.Fragment>
                <div className="d-block">
                    {/*{ this.state.preview ? <div dangerouslySetInnerHTML={{ __html: this.state.preview }} /> : null }*/}
                    <div className='margin-bottom-10'/>
                    { (this.state.selectedSubType === 'Scheduled' || !this.state.posts || (this.state.posts && this.state.posts.length < 1)) && !this.state.loader ?
                        this.noMessengerRenderer()
                        :
                        this.state.loader ?
                            this.tableLoaderRenderer()
                            :
                            (this.props.selectedType.name === 'Single Message') ?
                                <MuiThemeProvider theme={ this.getMuiTheme() }>
                                    <MUIDataTable
                                        title={ "" }
                                        data={ this.state.posts }
                                        columns={ columns }
                                        options={ options }
                                    />
                                </MuiThemeProvider>
                                :
                                <MuiThemeProvider theme={ this.getMuiTheme() }>
                                    <MUIDataTable
                                        title={ "" }
                                        data={ this.state.posts }
                                        columns={ columns }
                                        options={ options }
                                    />
                                </MuiThemeProvider>
                    }

                </div>
                {/*{ console.log(this.state.currentPage, this.state.totalPosts, this.state.totalPages, this.state.lastPageSize, this.state.lastPage)}*/}
                {/*{ console.log(this.state.currentPage, this.state.totalPosts, this.state.totalPages, this.state.lastPageSize, this.state.lastPage)}*/}
                <CampaignDetailsModal
                    showModal={this.state.campaignDetailsModal}
                    handleClose={() => this.setState({campaignDetailsModal: false})}
                    maxWidth={540}
                    history={this.props.history}
                    campaignId={this.state.campaignId}
                    sentFrom={this.state.sentFrom}
                    sendTime={this.state.sendTime}
                    message={this.state.message}
                    segments={this.state.segments}
                    summary={this.state.summary}
                />
            </React.Fragment>
        )
    }
}

export default sizeMe()(FBMessengerCampaignPerformance)